import * as React from "react"
import * as AccordionPrimitive from "@radix-ui/react-accordion"
import {ChevronDown, Plus, Minus} from "lucide-react"

import {cn} from "@/lib/utils"

const Faqs = AccordionPrimitive.Root

const FaqItem = React.forwardRef<
  React.ElementRef<typeof AccordionPrimitive.Item>,
  React.ComponentPropsWithoutRef<typeof AccordionPrimitive.Item>
>(({className, ...props}, ref) => (
  <AccordionPrimitive.Item
    ref={ref}
    className={cn("border-b", className)}
    {...props}
  />
))
FaqItem.displayName = "AccordionItem"

const FaqTrigger = React.forwardRef<
  React.ElementRef<typeof AccordionPrimitive.Trigger>,
  React.ComponentPropsWithoutRef<typeof AccordionPrimitive.Trigger>
>(({className, children, ...props}, ref) => (
  <AccordionPrimitive.Header className="flex">
    <AccordionPrimitive.Trigger
      ref={ref}
      className={cn(
        "flex flex-1 items-center gap-4 justify-start py-4 font-medium transition-all hover:underline [&[data-state=closed]>.minus]:hidden [&[data-state=open]>.plus]:hidden",
        className
      )}
      {...props}
    >
      <Plus className="plus h-4 w-4 shrink-0 transition-transform duration-200 text-primary"/>
      <Minus className="minus h-4 w-4 shrink-0 transition-transform duration-200 text-primary"/>
      {children}
    </AccordionPrimitive.Trigger>
  </AccordionPrimitive.Header>
))
FaqTrigger.displayName = AccordionPrimitive.Trigger.displayName

const FaqContent = React.forwardRef<
  React.ElementRef<typeof AccordionPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof AccordionPrimitive.Content>
>(({className, children, ...props}, ref) => (
  <AccordionPrimitive.Content
    ref={ref}
    className="overflow-hidden text-sm transition-all data-[state=closed]:animate-accordion-up data-[state=open]:animate-accordion-down"
    {...props}
  >
    <div className={cn("pb-4 pt-0", className)}>{children}</div>
  </AccordionPrimitive.Content>
))

FaqContent.displayName = AccordionPrimitive.Content.displayName

export {Faqs, FaqItem, FaqTrigger, FaqContent}
